export class RoundRobinApiSelector {
  constructor(apis) {
    this.apis = apis;
    this.__index = 0;
    this.__n = apis.length;
  }
  
  get() {
    const api = this.apis[this.__index];
    this.__index = (this.__index + 1) % this.__n;
    return api;
  }
}
